export class DepartmentInfo {
  DepartmentId: number
  DepartmentCode: string
  DepartmentName: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByDisplay: string
  UpdateDate: string
  UpdateBy: string
  rowOFFSet: number
  rowFetch: number
}
